import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useState } from 'react';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { IconButton, Box, Button, Card, CardContent, Container, Fab, FormControl, Grid, InputLabel, MenuItem, Select, Stack, TextField, Typography, Autocomplete } from '@mui/material'
import { KeyboardArrowLeftRounded } from '@mui/icons-material'
import { CloudUpload as CloudUploadIcon, Delete as DeleteIcon, } from '@mui/icons-material'
import { advanceOrRoyaltyPaymentPO } from './_mock/user';
import { DataGrid } from '@mui/x-data-grid';
import { FILE_NAME_VALIDATION_ERROR, PAYMENT_ROLES, allowedFileTypes } from '../../common/constants';
import { getCategoryList, getUrnList, paymentPoList, saveAdvancePayment, sendForPaymentApproval, getDocumentUploadDetails, downloadDocument, sendToSAPForPayment } from './paymentAPIs';
import { getLocalStorageItem } from '../../common/localStorageUtils';
import CustomDataGridToolbar from '../../common/customDataGridToolbar';
import { getPartiallyPaid } from './paymentAPIs';
import { format } from 'date-fns';
import { VALIDATION, capitalizeFunction, fileNameValidation, validateAmount } from '../../common/commonValidations';
import { openTextFieldMaxLength } from '../../common/commonValidations';
import { ConfirmationPopover } from '../../common/commonPopovers/confirmationPopover';
import { handleNumberFieldFocus } from '../../common/commonFunction';
import { ApproveIcon, CloseIcon } from '../../common/icons';

function CommonPaymentAddEditVerify({ paymentType }) {

    const { state } = useLocation();

    const rows = advanceOrRoyaltyPaymentPO;

    const columns = [
        {
            field: 'poNumber', headerName: 'PO Number', width: 100,
            valueGetter: (params) => {
                if (state?.selectedRow) {
                    return params?.row?.pitPono
                } else return params?.row?.poNumber
            }
        },
        { field: 'stakeholderName', headerName: 'Stakeholder Name', width: 150 },
        { field: 'poDescription', headerName: 'Description', width: 200 },
        { field: 'poAmount', headerName: 'PO Amount(INR)', width: 150, type: "number",
        valueGetter: (params) => params.value?.toFixed(2) },
        {
            field: 'advanceAmount', headerName: 'PO ' + paymentType + ' Amount(INR)', width: 200, type: "number",
            valueGetter: (params) => {
                if (state?.selectedRow) {
                    return params?.row?.poAdvancePaymentAmount?.toFixed(2)
                } else return params?.row?.advanceAmount?.toFixed(2)
            }
        },
        { field: 'poPartiallyPaidAmount', headerName: 'Partially ' + paymentType + ' Paid Amount(INR)', width: 260, type: "number",
        valueGetter: (params) => params.value?.toFixed(2) },
        {
            field: 'poDate', headerName: 'PO Date', width: 200, type: "date",
            valueGetter: (params) => {
                if (state?.selectedRow) {
                    return format(new Date(params?.row?.poDate), 'dd/MM/yyyy')
                } else return format(new Date(params?.row?.poApprovedDate), 'dd/MM/yyyy')
            }
        },
        { field: 'paymentCycle', headerName: 'Payment Cycle', width: 200 },
    ];

    const documentColumns = [
        {
            field: 'documentName', headerName: 'File Name', width: 200,
            renderCell: (params) => {
                return (
                    <Typography variant="fileName" onClick={() => downloadDocument(params?.row, "View")}> {params?.value}
                    </Typography>
                );
            }
        },
        { field: 'createdByName', headerName: 'Uploaded By', width: 200 },
        { field: 'createdOnFormatted', headerName: 'Uploaded On', width: 200 }
    ];

    const auth = 'Bearer ' + getLocalStorageItem('id_token');

    const { id } = useParams();
    let userRole = localStorage.getItem('role');
    const [partiallyPaid, setPartiallyPaid] = useState();
    const [poList, setPoList] = useState([]);
    const [details, setDetails] = useState({
        category: state ? state?.selectedRow?.stakeholderCatgeory : null,
        urn: state ? state?.selectedRow?.urn : null,
        po: state ? state?.selectedRow?.pitPono : null,
        advancePaymentAmount: state.selectedRow ? state?.selectedRow?.advancePaymentAmount : null,
        requesterRemark: state ? state?.selectedRow?.requesterRemark : null,
        approveAmount: userRole === PAYMENT_ROLES?.FinanceUser ? state?.selectedRow?.approveAmount : state?.selectedRow?.advancePaymentAmount,
        // approveAmount: userRole === PAYMENT_ROLES?.FinanceUser ? state?.selectedRow?.approveAmount : Number(state?.selectedRow?.advancePaymentAmount) - Number(state?.selectedRow?.poPartiallyPaidAmount),
        approverRemark: state ? state?.selectedRow?.approverRemark : null,
    });
    const [categoryList, setCategoryList] = useState();
    const [urnList, setUrnList] = useState({ stakeHolders: [] });
    const [selectedUrn, setSelectedUrn] = useState();
    const [selectedPo, setSelectedPo] = useState();
    const [saveResponse, setSaveResponse] = useState();
    const [actionResponse, setActionResponse] = useState();
    const [submit, setSubmit] = useState();
    const [dialogOpen, setDialogOpen] = useState(false);
    const [actionType, setActionType] = useState();
    const [actionText, setActionText] = useState();
    const [poGrnDetails, setPoGrnDetails] = useState();
    const [errorMessage, setErrorMessage] = useState({
        advancePaymentAmountError: "",
        approveAmountError: "",
        fileUploadError: "",
        requesterRemarkError: "",
    }
    )
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [documents, setDocuments] = useState([]);

    const navigate = useNavigate();
    const phone_regex = /^[1-9][0-9]*$/;

    const handleChange = (e, type) => {
        setErrorMessage({
            advancePaymentAmountError: "",
            approveAmountError: ""
        })
        if (type === "amount") {
            const validatedAmount = validateAmount(e.target.value);
            if(e.target.value === '') {
                setDetails({ ...details, [e.target.name]: '' });
            }
            if (validatedAmount) {
                setDetails({ ...details, [e.target.name]: validatedAmount });
            }
        }
        else if (type === "remark") {
            setDetails({ ...details, [e.target.name]: VALIDATION.noSpecialCharacterValidation(e.target.value) });
        }
        else {
            setDetails({ ...details, [e.target.name]: e.target.value });
        }
    }

    const autoHandleChange = (e, value, type) => {
        if (type === "urn") {
            setDetails({ ...details, [type]: value?.urn });
            setSelectedUrn(value);
            paymentPoList(value?.urn, paymentType + " Payment", setPoList)
        }
        if (type === "po") {
            // setDetails({ ...details, [type]: value?.poNumber});
            setSelectedPo(value);
            getPartiallyPaid(value?.poNumber, setPartiallyPaid, poList, details, setDetails, type);
        }
    }

    const handleClose = () => {
        setDialogOpen(false);
    };

    const onApprovalAction = (action, text) => {
        setSubmit(true);
        const tempArr = []
        selectedFiles?.map((item) => {
            tempArr.push({
                documentName: item?.fileName,
                documentBlobName: item?.blobFileName,
                documentContainerName: "paymentfiles",
                isActive: 1
            });
        });
        setDocuments(tempArr);
        if (!details?.approveAmount) {
            setErrorMessage({ ...errorMessage, approveAmountError: "This field is mandatory" });
        }
        else if ((Number(details?.approveAmount) > Number(state?.selectedRow?.advancePaymentAmount))) {
            setErrorMessage({ ...errorMessage, approveAmountError: "Approve amount cannot be more than the advance amount" })
        }
        // else if (submit && (details?.approveAmount > (state?.selectedRow?.advancePaymentAmount - state?.selectedRow?.poPartiallyPaidAmount))) {
        //     setErrorMessage({ ...errorMessage, approveAmountError: "Approve amount cannot be more than the difference between advance amount and partially paid amount" })
        // }
        else {
            setErrorMessage({ ...errorMessage, approveAmountError: "" });
            setActionType(action);
            setActionText(text);
            setDialogOpen(true);
        }
    }

    function onConfirmAction() {
        setDialogOpen(false);
        const tempArr = [];
        tempArr.push({
            id: state?.selectedRow?.id,
            approveAmount: details?.approveAmount,
            approverRemark: details?.approverRemark,
            documents: documents,
        })
        sendForPaymentApproval(tempArr, actionType, setActionResponse, paymentType, null, navigate);
    }

    const onSendToSAP = () => {
        setActionText("Send to SAP for payment");
        setDialogOpen(true);
    }

    function onConfirmSendToSAP() {
        setDialogOpen(false);
        const tempArr = [];
        tempArr.push({
            paymentId: state?.selectedRow?.id,
            "documents": documents,
        })
        sendToSAPForPayment(tempArr, setActionResponse, paymentType, null, navigate);
    }

    function onConfirmSubmit() {
        setDialogOpen(false);
        saveAdvancePayment(details, selectedUrn, selectedPo, documents, setSaveResponse, state?.selectedRow, paymentType, navigate, poList?.find(item => item.poNumber === details.po), partiallyPaid)
    }

    const onSubmit = () => {
        setSubmit(true);
        const tempArr = []
        selectedFiles?.map((item) => {
            tempArr.push({
                documentName: item?.fileName,
                documentBlobName: item?.blobFileName,
                documentContainerName: "paymentfiles",
                isActive: 1
            });
        });
        setDocuments(tempArr);
        if (details?.advancePaymentAmount > Number(poList?.find(item => item.poNumber === details.po).advanceAmount) - Number(partiallyPaid) || !details?.advancePaymentAmount || !details?.requesterRemark) {
            if (details?.advancePaymentAmount > Number(poList?.find(item => item.poNumber === details.po).advanceAmount) - Number(partiallyPaid)) {
                setErrorMessage({ ...errorMessage, advancePaymentAmountError: "Advance amount cannot be more than the difference between PO advance amount and PO partially paid amount" })
            }
            else if (!details?.advancePaymentAmount) {
                setErrorMessage({ ...errorMessage, advancePaymentAmountError: "This field is mandatory" })
            }
        }
        // else if (!details?.advancePaymentAmount.match(phone_regex)) {
        //     setErrorMessage({ ...errorMessage, advancePaymentAmountError: "Amount should not start with 0" })
        // }
        else {
            setActionText(state?.type === "Edit" ? "Update" : "Submit");
            setDialogOpen(true);
        }
    }

    const handleDocumentChange = (e, type) => {
        if (allowedFileTypes.indexOf(e.target.files[0].type) < 0) {
            return;
        }
        const choosenFiles = Array.prototype.slice.call(e.target.files)
        if (choosenFiles.some(file => file.size > 5000000)) {
            setErrorMessage({ ...errorMessage, fileUploadError: 'One of the selected file size is more than 5MB, select the files which size less than 5MB' });
        }
        else if(choosenFiles.some(file=>file.name.split('.').length > 2))
    {      
        setErrorMessage({ ...errorMessage, fileUploadError: "Double extension file detected pls select proper file"})
    }
    else if(choosenFiles.some(file=>fileNameValidation(file.name)))
    {      
        setErrorMessage({ ...errorMessage, fileUploadError: FILE_NAME_VALIDATION_ERROR})
    }
        else {
            //   setSelectedFiles(e.target.files);
            setErrorMessage({ ...errorMessage, fileUploadError: '' });
            choosenFiles.map((file) => {
                getDocumentUploadDetails(file, selectedFiles, setSelectedFiles)
            })
        }
    };

    const onDeleteFile = (id) => {
        const rows = [...selectedFiles];
        rows.splice(id, 1);
        setSelectedFiles(rows);
    }

    useEffect(() => {
        getCategoryList(setCategoryList)
    }, []);

    useEffect(() => {
        if (details?.category) {
            getUrnList(details?.category, setUrnList);
        }
    }, [details?.category]);

    // const poList = ['PO1', 'PO2'];

    return (
        <>
            <Helmet>
                <title> Create {paymentType} Payment </title>
            </Helmet>
            <Container maxWidth="xl">
                <Typography variant="h4" sx={{ mb: 2 }}>
                    <Fab onClick={() => { navigate(`../${paymentType.toLowerCase()}Payment`) }} size="small" aria-label="back" title='Back'>
                        <KeyboardArrowLeftRounded />
                    </Fab>  {paymentType} Payment
                </Typography>
                <Card>
                    <CardContent>
                        <Stack spacing={2} sx={{ pt: 1 }}>
                            {state?.type === "Create" && <> <FormControl sx={{ width: '30%' }}>
                                <InputLabel id="select-category-label">Stakeholder Type</InputLabel>
                                <Select
                                    label="Stakeholder Type"
                                    name="category"
                                    value={details?.category}
                                    onChange={(e) => handleChange(e)}
                                >
                                    <MenuItem value="">
                                        <em>Select</em>
                                    </MenuItem>
                                    {categoryList?.configs?.map(item => {
                                        return <MenuItem key={item?.value} value={item?.value}>{item?.value}</MenuItem>
                                    })}
                                </Select>
                            </FormControl>
                                <Autocomplete
                                    options={urnList?.stakeHolders}
                                    getOptionLabel={(option) => option?.urn}
                                    sx={{ width: "30%" }}
                                    onChange={(e, value) => autoHandleChange(e, value, "urn")}
                                    // value={details?.urn}
                                    renderInput={(params) => <TextField {...params} label="URN" />}
                                />
                                <Autocomplete
                                    id="combo-box-demo"
                                    options={poList}
                                    getOptionLabel={(option) => option?.poNumber}
                                    sx={{ width: "30%" }}
                                    // value={details?.po}
                                    onChange={(e, value) => autoHandleChange(e, value, "po")}
                                    renderInput={(params) => <TextField {...params} label="PO" />}
                                /></>}
                            {details.po && <>
                                <Card>
                                    <Box style={{ height: 220, width: '100%' }}>
                                        <DataGrid
                                            rows={state?.selectedRow ? [state?.selectedRow] : [{ ...poList?.find(item => item.poNumber === details.po), poPartiallyPaidAmount: partiallyPaid }]}
                                            // rows={state?.selectedRow ? [state?.selectedRow] : rows}
                                            columns={columns}
                                            pageSize={10}
                                            getRowId={(row) => {
                                                if (state?.selectedRow) {
                                                    return row.pitPono
                                                }
                                                else {
                                                    return row.poNumber
                                                }
                                            }}
                                            components={{
                                                Toolbar: CustomDataGridToolbar,
                                              }}
                                            componentsProps={{toolbar: {rows: state?.selectedRow ? [state?.selectedRow] : rows, columns: columns, fileName: paymentType + "Payment.xlsx" }}}
                                            />
                                    </Box>
                                </Card>
                                <TextField fullWidth
                                    required
                                    disabled={userRole !== PAYMENT_ROLES?.SCMEndUser || state?.type === "View"}
                                    error={submit && (!details?.advancePaymentAmount || details.advancePaymentAmount > Number(poList?.find(item => item.poNumber === details.po)?.advanceAmount) - Number(partiallyPaid))}
                                    helperText={errorMessage.advancePaymentAmountError}
                                    label={paymentType + " Payment(INR)"}
                                    color="info"
                                    rows={5}
                                    type="number"
                                    onFocus={handleNumberFieldFocus}
                                    name="advancePaymentAmount"
                                    onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+' || (evt.key === '0' && evt.target.value.length === 0)) && evt.preventDefault()}
                                    onChange={(e) => handleChange(e, "amount")}
                                    value={details?.advancePaymentAmount || ''}
                                    sx={{ width: "30%" }}
                                />
                                <TextField fullWidth
                                    required
                                    disabled={userRole !== PAYMENT_ROLES?.SCMEndUser || state?.type === "View"}
                                    error={submit && !details?.requesterRemark}
                                    helperText={submit && !details?.requesterRemark ? "This field is mandatory" : null}
                                    autoComplete="off"
                                    inputProps={{
                                        maxLength: openTextFieldMaxLength
                                    }}
                                    label="Remark"
                                    color="info"
                                    rows={5}
                                    name="requesterRemark"
                                    multiline
                                    onChange={(e) => handleChange(e, "remark")}
                                    value={details?.requesterRemark}
                                    InputProps={{ maxLength: 200 }}
                                    sx={{ width: "60%" }}
                                />
                                {userRole !== PAYMENT_ROLES?.SCMEndUser && <><TextField fullWidth
                                    required
                                    // error={submit && (!details?.approveAmount || (details?.approveAmount > (state?.selectedRow?.advancePaymentAmount - state?.selectedRow?.poPartiallyPaidAmount)))}
                                    error={submit && (!details?.approveAmount || Number(details?.approveAmount) > Number(state?.selectedRow?.advancePaymentAmount))}
                                    helperText={errorMessage?.approveAmountError}
                                    disabled={userRole !== PAYMENT_ROLES?.PaymentApprover || state?.selectedRow?.status !== "Pending_for_Approval"}
                                    autoComplete="off"
                                    label="Approve Amount"
                                    color="info"
                                    rows={5}
                                    name="approveAmount"
                                    type="number"
                                    onFocus={handleNumberFieldFocus}
                                    onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                                    onChange={(e) => handleChange(e, "amount")}
                                    value={details?.approveAmount}
                                    sx={{ width: "30%" }}
                                />
                                    <TextField fullWidth
                                        disabled={userRole !== PAYMENT_ROLES?.PaymentApprover || state?.selectedRow?.status !== "Pending_for_Approval"}
                                        autoComplete="off"
                                        label="Approver Remark"
                                        color="info"
                                        rows={5}
                                        inputProps={{
                                            maxLength: openTextFieldMaxLength
                                        }}
                                        name="approverRemark"
                                        multiline
                                        onChange={(e) => handleChange(e, "remark")}
                                        value={details?.approverRemark}
                                        InputProps={{ maxLength: 200 }}
                                        sx={{ width: "60%" }}
                                    /></>}
                                {state?.selectedRow?.documents && <Card>
                                    <Box sx={{
                                        height: 250, width: '100%'
                                    }}>
                                        <DataGrid
                                            rows={state?.selectedRow?.documents}
                                            columns={documentColumns}
                                            pageSize={2}
                                            components={{
                                                Toolbar: CustomDataGridToolbar,
                                              }}
                                            componentsProps={{toolbar: {rows: state?.selectedRow?.documents, columns: documentColumns, fileName: paymentType + "Payment.xlsx" }}}
                                            />
                                    </Box>
                                </Card>}
                            </>}
                        </Stack>
                        &nbsp;
                        {details.po && <>
                            <Stack sx={{ paddingLeft: '3%' }} direction="column">
                                <Box sx={{ width: '20%' }}>
                                    <p> Upload File</p>
                                    <Grid item xs={12} sm={6} md={6}>
                                        <Card style={{ backgroundColor: '#E7EBE8' }}>
                                            <Stack direction="column"
                                                justifyContent="center"
                                                alignItems="center">
                                                <IconButton disabled color="secondary" >
                                                    <CloudUploadIcon color="warning"
                                                        fontSize="large"
                                                    />
                                                </IconButton>
                                                <Button variant="contained" component="label" >Browse
                                                    <input id='fileUpload' type="file"
                                                        multiple
                                                        onChange={(e) => handleDocumentChange(e)}
                                                        accept='application/pdf, image/png, image/jpg, image/jpeg'
                                                        disabled={getLocalStorageItem('role') === PAYMENT_ROLES?.PaymentViewer}
                                                        placeholder="Upload"
                                                        style={{ display: "none" }}
                                                    />
                                                </Button>
                                                <label style={{ fontSize: '10px' }}>supported files:pdf,png, jpg, jpeg.</label>
                                                <div className='resource-knowledge-error-message' >{errorMessage?.fileUploadError}</div>
                                            </Stack>
                                        </Card>
                                    </Grid>
                                </Box>
                                <Grid item xs={12} sm={6} md={6}>
                                    {selectedFiles.map((file, index) => (
                                        <Stack direction="row">
                                            📁
                                            <Typography onClick={() => downloadDocument(file, "Create")} variant="fileName"> {file?.fileName}
                                            </Typography>
                                            <DeleteIcon color="error" fontSize="small" sx={{ mt: 0.5 }} onClick={() => onDeleteFile(index)} />
                                        </Stack>
                                    ))
                                    }
                                </Grid>
                            </Stack>
                            &nbsp;
                            &nbsp;
                            {userRole === PAYMENT_ROLES?.SCMEndUser && state?.type !== "View" && <Box display='flex' alignItems="center" justifyContent="center">
                                <Button sx={{ minWidth: 120 }} variant="contained" onClick={() => onSubmit()}>{state?.type === "Edit" ? "Update" : "Save"}</Button>
                                &nbsp;
                                &nbsp;
                                <Button sx={{ minWidth: 120, mr: 2 }} onClick={() => { navigate(`../${paymentType.toLowerCase()}Payment`) }} variant="outlined">Close</Button>
                            </Box>}
                            {userRole === PAYMENT_ROLES?.PaymentApprover && state?.selectedRow?.status === "Pending_for_Approval" && <Box display='flex' alignItems="center" justifyContent="center">
                                <Button startIcon={<ApproveIcon />} sx={{ minWidth: 120 }} variant="contained" onClick={() => onApprovalAction("approve", "Approve")}>Approve</Button>
                                &nbsp;
                                &nbsp;
                                <Button tartIcon={<CloseIcon />} sx={{ minWidth: 120, mr: 2 }} variant="contained" onClick={() => onApprovalAction("reject", "Reject")}>Reject</Button>
                            </Box>}
                            {userRole === PAYMENT_ROLES?.FinanceUser && state?.selectedRow?.status === "Approved" && <Box display='flex' alignItems="center" justifyContent="center">
                                <Button sx={{ minWidth: 120 }} variant="contained" onClick={() => onSendToSAP()}>Send to SAP for payment</Button>
                            </Box>}
                        </>}
                        &nbsp;
                        &nbsp;
                    </CardContent>
                </Card>
            </Container>
            <ConfirmationPopover
                onOpen={dialogOpen}
                onClose={handleClose}
                onConfirm={(actionText === "Update" || actionText === "Submit") ? onConfirmSubmit : actionText === "Send to SAP for payment" ? onConfirmSendToSAP : onConfirmAction}
                action={actionText}
            />
        </>
    )
}

export default CommonPaymentAddEditVerify